"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionMenu = ActionMenu;
exports.createMenu = void 0;
var _Ellipsis = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/general/Ellipsis.svg"));
var _Loading3QuartersOutlined2 = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/Loading3QuartersOutlined.svg"));
var _react = _interopRequireDefault(require("react"));
var _button = _interopRequireDefault(require("../../button"));
var _dropdown = _interopRequireDefault(require("../../dropdown"));
var _icon = _interopRequireDefault(require("../../icon"));
var _space = _interopRequireDefault(require("../../space"));
var _tooltip = _interopRequireDefault(require("../../tooltip"));
var _jsxRuntime = require("react/jsx-runtime");
/**
 * @deprecated 此类型已被废弃，请使用 ActionMenuItem 替代
 */

const isDividerItem = item => {
  return (item === null || item === void 0 ? void 0 : item.type) === 'divider';
};
const createMenuItems = items => {
  const baseSubMenuClassName = "table-actionSubMenu";
  const menuItems = items.reduce((acc, cur) => {
    if (cur.hidden) {
      return acc;
    }
    let menuItem = null;
    const label = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_space.default, {
      block: true,
      children: [/*#__PURE__*/_react.default.isValidElement(cur.icon) ? cur.icon : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        children: cur.text
      })]
    });
    if (cur.children) {
      const children = createMenuItems(cur.children);
      if (children.length) {
        menuItem = {
          ...cur,
          label,
          icon: null,
          popupClassName: baseSubMenuClassName,
          children
        };
      }
    } else {
      const tooltipProps = cur.tooltips ? cur.tooltips : {
        title: undefined
      };
      menuItem = {
        ...cur,
        label: tooltipProps.title ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_tooltip.default, {
          placement: "topLeft",
          ...tooltipProps,
          children: label
        }) : label,
        icon: null,
        className: tooltipProps.title ? 'hasTooltip' : undefined
      };
    }
    if (menuItem) {
      const lastAccItem = acc[acc.length - 1];
      if (lastAccItem && !isDividerItem(lastAccItem) && cur.divider === 'before') {
        acc.push({
          type: 'divider',
          key: "".concat(cur.key, "-divider-before")
        });
      }
      acc.push(menuItem);
      if (cur.divider === 'after') {
        acc.push({
          type: 'divider',
          key: "".concat(cur.key, "-divider-after")
        });
      }
    }
    return acc;
  }, []);

  // 删除最后一个divider
  if (isDividerItem(menuItems[menuItems.length - 1])) {
    menuItems.pop();
  }
  return menuItems;
};
const createMenu = menu => {
  const baseClassName = "table-actionMenu";
  return {
    className: baseClassName,
    items: createMenuItems(menu)
  };
};
exports.createMenu = createMenu;
function ActionMenu(_ref) {
  let {
    menu,
    unfold,
    disabled,
    loading,
    buttonProps,
    placement = 'bottom'
  } = _ref;
  const _buttonProps = {
    type: 'text',
    size: 's',
    textBaseColor: true,
    ...buttonProps
  };
  if (loading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.default, {
      disabled: true,
      ..._buttonProps,
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
        type: "Loading3QuartersOutlined",
        block: true
      })
    });
  }
  const isEmptyMenu = menu => {
    let hasVisibleMenu = false;
    function checkMenuShouldVisible(menu) {
      for (let i = 0; i < ((menu === null || menu === void 0 ? void 0 : menu.length) || 0); i++) {
        var _item$children, _item$children2;
        const item = menu[i];
        if (!item.hidden && !((_item$children = item.children) !== null && _item$children !== void 0 && _item$children.length)) {
          hasVisibleMenu = true;
        }
        if ((_item$children2 = item.children) !== null && _item$children2 !== void 0 && _item$children2.length) {
          checkMenuShouldVisible(item.children);
        }
      }
    }
    menu && checkMenuShouldVisible(menu);
    return !hasVisibleMenu;
  };
  if (!menu || isEmptyMenu(menu)) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.default, {
      ..._buttonProps,
      disabled: true,
      children: "-"
    });
  }
  if (disabled && !unfold) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.default, {
      ..._buttonProps,
      disabled: true,
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
        type: "general/Ellipsis",
        block: true
      })
    });
  }
  if (unfold) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_space.default, {
      size: 0,
      children: menu.filter(item => !item.hidden).map(item => {
        var _buttonProps$textBase;
        const tooltipProps = item.tooltips ? item.tooltips : {
          title: undefined
        };
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_tooltip.default, {
          getPopupContainer: t => t.parentNode,
          ...tooltipProps,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.default, {
            ..._buttonProps,
            textBaseColor: (_buttonProps$textBase = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.textBaseColor) !== null && _buttonProps$textBase !== void 0 ? _buttonProps$textBase : false,
            icon: item.icon,
            disabled: item.disabled,
            danger: item.danger,
            onClick: item.onClick,
            children: item.text
          })
        }, item.key);
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdown.default, {
    placement: placement,
    menu: createMenu(menu),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.default, {
      ..._buttonProps,
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
        type: "general/Ellipsis",
        block: true
      })
    })
  });
}